import React, { memo } from 'react'
import { Button } from '@mui/material'
import Grid from '@mui/material/Grid2'
import { useIntl } from 'react-intl'
import Text, { TEXT_TYPES } from 'components/designSystem/Text'
import sx from './styles'

const NotInterestedModal = ({
  subtitle,
  handleCloseModal,
  onCancelConfirm,
  ctaTitle,
  withBorder = false,
}) => {
  const { formatMessage: f } = useIntl()
  return (
    <>
      <Text
        type={TEXT_TYPES.body.x1}
        sx={sx.body}
      >
        {subtitle}
      </Text>
      <Grid container>
        {handleCloseModal && (
          <Grid size={12}>
            <Button
              sx={{ ...sx.ctaModal, ...sx.ctaSeeOffer }}
              onClick={handleCloseModal}
            >
              {ctaTitle || f({ id: 'NO' })}
            </Button>
          </Grid>
        )}
        {onCancelConfirm && (
          <Grid size={12}>
            <Button
              sx={{
                ...sx.ctaModal,
                ...sx.seeOfferCancelCta,
                ...{ mb: 0, borderWidth: withBorder ? 1 : 0 },
              }}
              onClick={onCancelConfirm}
            >
              {f({ id: 'YES' })}
            </Button>
          </Grid>
        )}
      </Grid>
    </>
  )
}

export default memo(NotInterestedModal)
